





























import Vue, { PropOptions } from 'vue'
import { Announcement } from '@/common/types/announcements'

export default Vue.extend({
  props: {
    announcements: {
      type: Array,
      required: true
    } as PropOptions<Announcement[]>
  },
  computed: {
    infoAnnouncements(): Announcement[] {
      return this.announcements.filter(announcement => {
        return announcement.announcement_type === 'info'
      })
    }
  }
})
